// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!./colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!./variables.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================

    Overrides for page level styling
    - Pages have a legacy default styling applied with the .page class
    - > those styles cannot be overridden at the React .pageContainer level
    - > add styling here to override the .page class's default styling

    ====================== */
    
/* Wrapping CSS in the :global pseudo selector tells CSS Modules not to change the class names */
 {
    .pages_dailySummary__9iK94.pages_page__\\+qARe {
        background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_115"]};
        padding-left: 0;
        padding-right: 0;
    }
    
    @media (min-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["startMD"]}) {
        .pages_dailySummary__9iK94.pages_page__\\+qARe {
            padding-left: 30px;
            padding-right: 30px;
        }
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/styles/pages.module.css"],"names":[],"mappings":"AAAA;;;;;;;4BAO4B;;AAK5B,gGAAgG;AAChG;IACI;QACI,wDAAqB;QACrB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI;YACI,kBAAkB;YAClB,mBAAmB;QACvB;IACJ;AACJ","sourcesContent":["/*  ======================\n\n    Overrides for page level styling\n    - Pages have a legacy default styling applied with the .page class\n    - > those styles cannot be overridden at the React .pageContainer level\n    - > add styling here to override the .page class's default styling\n\n    ====================== */\n\n@value color_115 from './colors.module.css';\n@value (startMD) from './variables.module.css';\n    \n/* Wrapping CSS in the :global pseudo selector tells CSS Modules not to change the class names */\n:global {\n    .dailySummary.page {\n        background: color_115;\n        padding-left: 0;\n        padding-right: 0;\n    }\n    \n    @media (min-width: startMD) {\n        .dailySummary.page {\n            padding-left: 30px;\n            padding-right: 30px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color_115": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_115"]}`,
	"startMD": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["startMD"]}`,
	"dailySummary": `pages_dailySummary__9iK94`,
	"page": `pages_page__+qARe`
};
export default ___CSS_LOADER_EXPORT___;
